const getPrefixedCookieName = (cookieName) => {
  const cookieNamePrefix = window.headerFooterData?.cookieNamePrefix;

  if (!cookieNamePrefix) {
    return cookieName;
  }

  return `${cookieNamePrefix}-${cookieName}`;
};

export default getPrefixedCookieName;
